import { Pipe, PipeTransform } from '@angular/core';
import { FngSelectOption } from '@festo-ui/angular';
import { Identity } from 'app/models/api/identity';

@Pipe({
  name: 'getTenantOptions',
})
export class GetTenantOptionsPipe implements PipeTransform {
  transform(profile: Identity | undefined): FngSelectOption[] {
    if (!profile) {
      return [];
    }

    return profile.tenants
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(t => ({
        value: t,
        text: t.name
      }));
  }
}
